export default "__VITE_ASSET__GrZh7e0x__"